module.exports = __webpack_public_path__ + "img/desert.a65c3b69.svg";